import React from 'react';
import './PopupModel.css';

const PopupModel = ({ show, onClose, title, message, isSuccess,className = '' }) => {
  if (!show) return null;

  return (
    <div className={`popup-overlay ${className}`}>
      <div className="popup-content">
        <h2 className={`popup-title ${isSuccess ? 'success' : 'error'}`}>{title}</h2>
        <p>{message}</p>
        <button
          onClick={onClose}
          className={`popup-close-btn ${isSuccess ? 'success' : 'error'}`}
          style={className.includes('admin-popup') ? { color: 'white' } : {}}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default PopupModel;
